import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ic_team",
  "use": "icon-ic_team-usage",
  "viewBox": "0 0 100 125",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 125\" id=\"icon-ic_team\">\n<title>15</title>\n<g>\n\t<path d=\"M81.3,19.4C63.9,19.1,54.5,11.3,52.1,9c-1.2-1.1-3-1.1-4.2,0c-2.4,2.4-11.8,10.1-29.2,10.5c-1.6,0.1-2.9,1.4-2.9,3v22.1\n\t\tc0,15.5,7,30.2,18.6,39.3c4.4,3.5,9.4,6.1,14.7,7.8h1.8c5.3-1.7,10.3-4.3,14.7-7.8c11.6-9.1,18.6-23.8,18.6-39.3V22.4\n\t\tC84.2,20.8,82.9,19.5,81.3,19.4z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ic_team.svg
// module id = phNT
// module chunks = 1